<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'ItineraryMatrixAgesModal',
  data() {
    return {
      toggled: false,
    };
  },
  created() {
    this.getItineraryMatrixAges(this.$route.params.domainId);
    this.getItineraryMatrixPrices({
      itineraryId: this.$route.params.id,
      domainId: this.$route.params.domainId,
    });
    this.calclutatePriceIntervals();
  },
  computed: {
    ...mapState({
      matrixAges: state => state.itinerary.matrixAges,
      matrixPrices: state => state.itinerary.matrixPrices,
      itineraryTexts: state => state.itinerary.itineraryTexts,
      saving: state => state.itinerary.saveMatrixPrices.loading,
      calculatedMatrixPrices: state => state.itinerary.calculatedMatrixPrices,
      settingAllPrices: state => state.itinerary.settingAllPrices.loading,
    }),
    ...mapGetters({
      getMappedMatrixPrices: 'itinerary/getMappedMatrixPrices',
      mainItineraryText: 'itinerary/mainItineraryText',
      generalItineraryTexts: 'itinerary/generalItineraryTexts',
      importantItineraryTexts: 'itinerary/importantItineraryTexts',
    }),
    loading() {
      return this.matrixAges.loading
        || this.calculatedMatrixPrices.loading;
    },
  },
  methods: {
    ...mapActions({
      getItineraryMatrixAges: 'itinerary/getItineraryMatrixAges',
      getItineraryMatrixPrices: 'itinerary/getItineraryMatrixPrices',
      calclutatePriceIntervals: 'itinerary/calclutatePriceIntervals',
      setMatrixPrice: 'itinerary/setMatrixPrice',
      setAllMatrixWithCalculated: 'itinerary/setAllMatrixWithCalculated',
      setMatrixActiveStatus: 'itinerary/setMatrixActiveStatus',
      saveMatrixPrices: 'itinerary/saveMatrixPrices',
      getItineraryTexts: 'itinerary/getItineraryTexts',
      saveItineraryTexts: 'itinerary/saveItineraryTexts',
      updateItineraryText: 'itinerary/updateItineraryText',
      addItineraryText: 'itinerary/addItineraryText',
    }),
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-btn
      :loading="loading"
      :disabled="loading"
      color="primary"
      @click="toggled = true"
    >
      Matrix ages
    </v-btn>
    <v-dialog
      v-if="toggled"
      v-model="toggled"
      width="1500"
    >
      <v-card class="pa-4">
        <div class="d-flex justify-bewteen align-center">
          <h1>Price calendar</h1>
          <v-btn
            :loading="settingAllPrices"
            :disabled="settingAllPrices"
            color="warning"
            @click="setAllMatrixWithCalculated()"
          >
            Overwrite all prices with calculated
          </v-btn>
        </div>
        <table>
          <thead>
            <tr>
              <th>Booking from</th>
              <th>Booking to</th>
              <th>Arrival from</th>
              <th>Arrival to</th>
              <th v-for="(matrixAge, index) in matrixAges.items" :key="`header-ages-${index}`">
                {{ matrixAge.description }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(priceInterval, intervalIndex) in getMappedMatrixPrices"
              :key="`price-interval-${intervalIndex}`"
            >
              <td>{{ priceInterval.bookingFrom | moment('DD-MM-YYYY') }}</td>
              <td>{{ priceInterval.bookingTo | moment('DD-MM-YYYY') }}</td>
              <td>{{ priceInterval.arrivalFrom | moment('DD-MM-YYYY') }}</td>
              <td>{{ priceInterval.arrivalTo | moment('DD-MM-YYYY') }}</td>
              <td v-for="(price, priceIndex) in priceInterval.prices" :key="`interval-ages-${priceIndex}`">
                <div class="d-flex align-center">
                  <div class="price-block">
                    <input
                      :value="price.price"
                      solo
                      @change="setMatrixPrice({ price, newPrice: $event.target.value, format: false })"
                    />
                    <input
                      :value="price.calculatedPrice"
                      solo
                      disabled
                    />
                  </div>
                  <v-icon @click="setMatrixPrice({ price, newPrice: price.calculatedPrice, format: true })">
                    sync
                  </v-icon>
                </div>
              </td>
            </tr>
            <tr>
              <td />
              <td />
              <td />
              <td>Use pax group</td>
              <td v-for="(matrixAge, matrixIndex) in matrixPrices.items" :key="`ages-checked-${matrixIndex}`">
                <v-checkbox
                  :input-value="matrixAge.enabled"
                  class="justify-center"
                  @change="setMatrixActiveStatus(matrixIndex)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex">
          <v-btn
            :loading="saving"
            :disabled="saving"
            color="success"
            @click="saveMatrixPrices({
              itineraryId: +$route.params.id,
              domainId: +$route.params.domainId,
            })"
          >
            Save prices
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
  .price-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 25px 0;
    border: 1px solid #e0dfdf;
  }
  table, th, td {
    border-collapse: collapse;
  }
  thead {
    background-color: #0b3441;
    color: white;
    height: 50px;
  }
  th, td {
    padding: 10px;
    text-align: center;
  }
  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
  tr:last-child {
    background-color: unset;
    border-top: 1px solid lightgray;
  }
  input {
    width: 80%;
    height: 30px;
    -moz-appearance: textfield;
    border: 1px solid grey;
    border-radius: 5px;
    outline: none;
    text-align: center;
    background-color: white;

    &:disabled {
      background-color: #e2e2e2;
      color: #4e4e4e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryMatrixAgesModal.vue